import React from "react";
import { useNavigate } from "react-router-dom";

export const MvpLandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mvp-landing" style={{ 
      backgroundColor: "var(--ink)", 
      color: "var(--fg)", 
      minHeight: "100vh", 
      padding: "40px 20px",
      fontFamily: "Segoe UI, system-ui, sans-serif"
    }}>
      <main style={{ maxWidth: "600px", margin: "0 auto", textAlign: "center" }}>
        <h1 style={{ 
          fontFamily: "Fraunces, Georgia, serif", 
          fontSize: "clamp(32px, 5vw, 48px)", 
          marginBottom: "24px",
          color: "var(--lilac)" 
        }}>
          Seu Mapa Astral Completo
        </h1>
        
        <p style={{ 
          color: "var(--muted)", 
          fontSize: "18px", 
          marginBottom: "40px",
          lineHeight: "1.6" 
        }}>
          Descubra a profundidade do seu caminho cósmico com um relatório detalhado escrito por nossa IA sensitiva.
        </p>

        <div style={{ 
          background: "var(--card)", 
          border: "1px solid var(--line)", 
          borderRadius: "24px", 
          padding: "32px",
          boxShadow: "0 20px 50px rgba(0,0,0,0.3)"
        }}>
          <div style={{ 
            color: "var(--gold)", 
            fontSize: "14px", 
            textTransform: "uppercase", 
            letterSpacing: "1px",
            marginBottom: "12px",
            fontWeight: "600"
          }}>
            Oferta Especial MVP
          </div>
          
          <div style={{ 
            fontSize: "42px", 
            fontWeight: "700", 
            marginBottom: "24px",
            fontFamily: "Fraunces, Georgia, serif"
          }}>
            R$ 29,90
          </div>

          <p style={{ 
            color: "var(--muted)", 
            fontSize: "15px", 
            marginBottom: "32px",
            lineHeight: "1.5" 
          }}>
            Receba seu relatório completo via e-mail e WhatsApp após a confirmação do pagamento via Pix.
          </p>

          <button 
            onClick={() => navigate("/quiz")} 
            style={{ 
              width: "100%", 
              padding: "16px", 
              borderRadius: "//999px", 
              border: "none", 
              background: "linear-gradient(135deg, var(--accent), var(--accent2))", 
              color: "#fff", 
              fontWeight: "600", 
              fontSize: "16px", 
              cursor: "pointer" 
            }}
          >
            Quero meu relatório completo
          </button>
        </div>

        <p style={{ 
          marginTop: "32px", 
          fontSize: "13px", 
          color: "var(--muted)" 
        }}>
          Pagamento seguro via Pix. Entrega rápida.
        </p>
      </main>
    </div>
  );
};
